import { render, staticRenderFns } from "./AddRfqItemModal.vue?vue&type=template&id=68f586e4"
import script from "./AddRfqItemModal.vue?vue&type=script&lang=js"
export * from "./AddRfqItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports